// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"341":"669b4c40","488":"9c1cd933","539":"c8f392d6","607":"3be4c387","655":"20be2b60","695":"61151d4a","711":"8e7b3b15","823":"8f6481d2","960":"dc2f83e0","963":"390b77aa","985":"f6bdcbc7"}[chunkId] + ".chunk.js";
};